import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import useAuth from '../app/hooks/use-auth';
import { all_routes } from './all-routes';

/**
 * PrivateRoute
 * Only allows access to children if the user is authenticated.
 * Otherwise, redirects to the login page.
 */
export const PrivateRoute: React.FC = () => {
  const { isTokenValid } = useAuth();
  const isAuthenticated = localStorage.getItem('token');
  if (!isTokenValid(isAuthenticated)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to={all_routes.login} replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to={all_routes.login} replace />;
};

/**
 * PublicRoute
 * Only allows access to children if the user is NOT authenticated.
 * Otherwise, redirects to the dashboard (or home).
 */
export const PublicRoute: React.FC = () => {
  const isAuthenticated = localStorage.getItem('token');
  return !isAuthenticated ? <Outlet /> : <Navigate to={all_routes.dashboard} replace />;
};
